module.exports = __webpack_public_path__ + "static/img/9.6fb8563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/9.png
// module id = lTxH
// module chunks = 0